
export type Language = 'ar' | 'en';
export type Direction = 'rtl' | 'ltr';

export const defaultLanguage: Language = 'ar';

export const languageConfig: Record<Language, { name: string; nativeName: string; dir: Direction }> = {
    ar: { name: 'Arabic', nativeName: 'العربية', dir: 'rtl' },
    en: { name: 'English', nativeName: 'English', dir: 'ltr' }
};

export const STORAGE_KEY = 'india-place-language';
